import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import apiClient from '../../../api/apiClient';
import { Button, Form, InputGroup, Container, Row, Col, Badge, Pagination } from 'react-bootstrap';
import { PlusIcon } from '../../../utils/FontIcon';
import ViewOptions from "../Questions/ViewOptions";
import { PopupModel, ShowMoreText, Input } from '../../shared';
import { publish, subscribe, unsubscribe } from '../../../utils/pubsubWrapper';
import { levelConfig,setSession,getSession } from '../../../utils/utils';
import { GETQUIZ } from '../../../utils/ApiEndPoint';

const CourseQuestionList = ({ reset, level }) => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [questions, setQuestions] = useState([]);
    const [selectedQuestionList, setSelectedQuestionList] = useState([]);
    const [search, setSearch] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [popupData, setPopupData] = useState({
        show: false,
        title: '',
        type: '',
        selectedItem: {},
    });
    const [selectedLvel, setSelectedLevel] = useState(level || '');
    const pageSize = 10;
    useEffect(() => {
        setSelectedQuestionList([]);
    }, [reset])
    useEffect(() => {
        fetchQuestion();
    }, []);
    useEffect(() => {
        const pubsubToken = subscribe('SELECTED_QUESTION', (question) => {
            setSelectedQuestionList(question);
        });
        return () => unsubscribe(pubsubToken);
    }, []);
    const fetchQuestion = async () => {
        setLoading(true)
        apiClient.get(GETQUIZ)
            .then((response) => {
                if (response.status === 200) {
                    setQuestions(response.data);
                } else {
                    setError('Failed to load questions');
                }
            }).catch((error) => {
                setError('Failed to load questions');
            }).finally(() => {
                setLoading(false);
            });
    };
    const filteredByLevel = selectedLvel ? questions.filter(q => {
        const skilLevel = q.skillLevel || 'beginner';
        return skilLevel.toLowerCase() === selectedLvel.toLowerCase();
    }) : questions;
    const filteredQuestions = filteredByLevel.filter(question => {
        const searchLower = search.toLowerCase();
        return (
            (question.title && question.title.toLowerCase().includes(searchLower)) ||
            (Array.isArray(question.tags) ? question.tags.join(' ').toLowerCase() : '').includes(searchLower)
        );
    });
    const paginatedQuestionnaire = filteredQuestions.slice(
        (currentPage - 1) * pageSize,
        currentPage * pageSize
    );
    const totalPages = Math.ceil(filteredQuestions.length / pageSize);
    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };
    const handelAddQuestion = (e) => {
        navigate('/addmanagequestionnaire');
    }
    const handelSelected = (question) => {
        const isSelected = selectedQuestionList.some(v => (v._id === question._id || v.refId === question._id));
        if (isSelected) {
            setSelectedQuestionList(prev => prev.filter(v => (v._id !== question._id && v.refId !== question._id)));
            publish('REMOVE_ITEM', question);
        } else {
            setSelectedQuestionList(prev => [...prev, question]);
            publish('ADD_ITEM', {
                "type": "quiz",
                "refId": question._id,
                "titleOverride": question.title
            });
        }

    }
    const handleCloseModal = () => {
        setPopupData({
            show: false,
            title: '',
            type: '',
            selectedItem: {},
        });
    };
    const onHandelChange = (e) => {
        const { name, value } = e.target;
        if (name === 'level') {
            setSelectedLevel(value);
            const courseLevels = getSession('levelForm');
            setSession('levelForm', {
                ...courseLevels,
                'questionLevel': value
            });
        } 
    }


    if (loading) return <p>Loading questions...</p>;
    return (
        <Container fluid className='p0'>
            <Row className="justify-content-between align-items-center mb-1">
                <Col xs={6} md={6} className='pright0'>
                    <h6 className='m0'>Assessment Library <Badge className='list-selected-badge' style={{display:'table-caption'}}>{selectedQuestionList.length} Selected</Badge></h6>
                </Col>
                <Col xs={6} md={6}>
                    <Button variant="outline-dark" className='addbtn-small fright' onClick={handelAddQuestion} title='+ Add Assessment'><PlusIcon style={{ fontSize: '10px' }} /> Add Assessment</Button>
                </Col>
            </Row>

            {error ? <Container className='video-listing-bg'><p className='text-center'>{error}</p></Container> :
                <Container className='video-listing-bg'>
                    <Row>
                        <Col lg={12} xs={12}>
                            <Input
                                label="Difficulty Level"
                                type="select"
                                name="level"
                                value={selectedLvel}
                                onChange={onHandelChange}
                                options={levelConfig}
                            />
                        </Col>
                        <Col lg={12} style={{ position: 'relative' }}>
                            <InputGroup>
                                <Form.Control
                                    placeholder="Search questionnaire..."
                                    type='search'
                                    value={search}
                                    onChange={e => setSearch(e.target.value)}
                                    className='searchbox-input'
                                />
                            </InputGroup>
                            <span className='search-icon' style={{ top: '-14px', position: 'absolute', right: '-5px' }}></span>
                        </Col>
                    </Row>
                    <Row style={{ height: '230px', overflow: 'hidden scroll', padding: '0.8rem' }}>
                        {paginatedQuestionnaire.map((question, idx) => {
                            return question.title &&
                                <Col lg={12} className='mt-2 mb-2 ' key={`question_${idx}`}>
                                    <Row>
                                        <Col lg={1} xs={2} className='listed-assessment'>
                                            <Form.Check type="checkbox" checked={selectedQuestionList.some(q => q._id === question._id || q.refId === question._id)} onChange={(e) => {
                                                handelSelected(question);
                                            }} />
                                        </Col>
                                        <Col lg={11} xs={10} style={{ cursor: 'pointer' }}>
                                            <span className='fw-600 d-block' onClick={() => {
                                                setPopupData({
                                                    show: true,
                                                    title: question.title,
                                                    type: 'quiz',
                                                    selectedItem: question
                                                });
                                            }}>{question.title}</span>
                                            <ShowMoreText text={question.description} styleClass='text-muted' />
                                        </Col>
                                    </Row>
                                </Col>
                        }
                        )}
                    </Row>
                    <Row>
                        <div className="d-flex justify-content-end course-videolist-pagination">
                            <Pagination className='mypagination-listing'>
                                <Pagination.First onClick={() => handlePageChange(1)} disabled={currentPage === 1} />
                                <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} />
                                {[...Array(totalPages)].map((_, idx) => (
                                    <Pagination.Item
                                        key={idx + 1}
                                        active={currentPage === idx + 1}
                                        onClick={() => handlePageChange(idx + 1)}
                                    >
                                        {idx + 1}
                                    </Pagination.Item>
                                ))}
                                <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} />
                                <Pagination.Last onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages} />
                            </Pagination>
                        </div>
                    </Row>
                </Container>}
            {popupData.show && popupData.type === 'quiz' ?
                <PopupModel
                    size='lg'
                    showModal={popupData.show}
                    handleCloseModal={handleCloseModal}
                    title={popupData.title}
                    type={popupData.type}
                >
                    <Row>
                        {popupData?.selectedItem?.questions?.map((question, index) => {
                            return <Col lg={12} key={index} className='question-preview-listing'>
                                <ViewOptions question={question} />
                            </Col>
                        })}
                    </Row>
                </PopupModel> : null}
        </Container>
    );
};

export default CourseQuestionList;